import React, { useContext } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { icons } from "../../../constants";
import { TranslationsContext } from "../../../utils/TranslationsContext";
import { useTheme } from "../../../utils/ThemeContext";
import IconWithTooltip from "../../IconWithTooltip/IconWithTooltip";

// One hint key per dizajnOpcije field (see gs.akr/helpers/pdf.js for what
// each option actually gates on the printed card).
const HINT_KEYS = {
  qr: "ACCREDITATION_OPTION_QR_HINT",
  ime: "ACCREDITATION_OPTION_IME_HINT",
  prezime: "ACCREDITATION_OPTION_PREZIME_HINT",
  slika: "ACCREDITATION_OPTION_SLIKA_HINT",
  entitet: "ACCREDITATION_OPTION_ENTITET_HINT",
  pozicija: "ACCREDITATION_OPTION_POZICIJA_HINT",
  akreditacija: "ACCREDITATION_OPTION_AKREDITACIJA_HINT",
};

const AccreditationSelector = ({ options, onUpdateOptions, disabled }) => {
  const { t } = useContext(TranslationsContext);
  const { theme } = useTheme();

  const isDisabled = disabled ?? false;

  const toggleOption = (key) => {
    if (isDisabled) return; // blokiraj kada je disabled
    const updatedOptions = {
      ...options,
      [key]: !options[key],
    };
    onUpdateOptions?.(updatedOptions);
  };

  const handleKeyDown = (e, key) => {
    if (isDisabled) return;
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      toggleOption(key);
    }
  };

  return (
    <div
      className="flex-direction-column gap-8 width-100 accreditation-selector"
      aria-disabled={isDisabled}
      style={isDisabled ? { opacity: 0.6 } : undefined}
    >
      <p className="inria-sans-400 font-12 accreditation-selector-title">
        {t("SHOW_ON_ACCREDITATION")}
      </p>

      <div className="flex-direction-column accreditation-selector-table">
        {Object.entries(options).map(([key, value]) =>
          key !== "dizajn" && key !== "grupa" ? (
            <div
              key={key}
              className="flex-direction-row items-center gap-24 accreditation-selector-row"
              role="button"
              tabIndex={isDisabled ? -1 : 0}
              onClick={() => toggleOption(key)}
              onKeyDown={(e) => handleKeyDown(e, key)}
              aria-pressed={!!value}
              aria-disabled={isDisabled}
              style={
                isDisabled ? { cursor: "not-allowed" } : { cursor: "pointer" }
              }
              title={isDisabled ? t("DISABLED") : undefined}
            >
              <img
                src={
                  value
                    ? theme === "light"
                      ? icons.check_in
                      : icons.check_in_dark
                    : theme === "light"
                    ? icons.check_out
                    : icons.check_out_dark
                }
                alt={value ? "checked" : "unchecked"}
                className="pointer"
                style={isDisabled ? { cursor: "not-allowed" } : undefined}
              />
              <p
                className="inria-sans-400 font-12 gray-text"
                style={{
                  color: value ? "var(--text-black)" : "var(--text-gray)",
                }}
              >
                {key}
              </p>
              {HINT_KEYS[key] && (
                <div
                  className="accreditation-selector-hint"
                  onClick={(e) => e.stopPropagation()}
                >
                  <IconWithTooltip tooltip={t(HINT_KEYS[key])}>
                    <img
                      src={icons.info}
                      alt="info"
                      width={12}
                      height={12}
                      className="pointer"
                    />
                  </IconWithTooltip>
                </div>
              )}
            </div>
          ) : null
        )}
      </div>
    </div>
  );
};

export default AccreditationSelector;
